import { render } from "./StoppageAddUpdateModal.vue?vue&type=template&id=2c6c3e7a"
import script from "./StoppageAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./StoppageAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__